import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigService } from '@dexio/common';

@Injectable({
  providedIn: 'root'
})
export class ProjectService {

  constructor(private readonly configs: AppConfigService, private readonly http: HttpClient) { }

  getProjects() {
    return this.http.get(`${this.configs.get().apiUrl}/projects?includeClosed=true`);
  }
}
